exports.Crypto = function() {
    return window.crypto
}
